import { SVGProps } from 'react'

const NewAudienceIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="136"
      height="128"
      viewBox="0 0 151 133"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M49.8867 67C68.3192 67 83.2617 52.0575 83.2617 33.625C83.2617 15.1925 68.3192 0.25 49.8867 0.25C31.4542 0.25 16.5117 15.1925 16.5117 33.625C16.5117 52.0575 31.4542 67 49.8867 67Z"
        fill="#7181FF"
      />
      <path
        d="M49.8868 77.5C22.3555 77.5338 0.0452286 99.8774 0.0117188 127.45C0.0117188 130.515 2.49275 133 5.55331 133H94.2201C97.2807 133 99.7617 130.515 99.7617 127.45C99.7285 99.8774 77.4182 77.5338 49.8868 77.5Z"
        fill="#7181FF"
      />
      <path
        d="M137.534 47.9688C130.293 48.3294 124.706 54.4753 125.035 61.7174C125.364 54.4753 119.777 48.3294 112.536 47.9688C105.296 48.3294 99.7083 54.4753 100.037 61.7174C100.037 72.529 114.136 85.1964 121.16 90.8335C123.425 92.6468 126.645 92.6468 128.91 90.8335C135.934 85.209 150.033 72.529 150.033 61.7174C150.362 54.475 144.775 48.3294 137.534 47.9688Z"
        fill="#7181FF"
      />
    </svg>
  )
}

export default NewAudienceIcon
